<component v-if="config" :is="config.component" v-bind="config"></component>